// Styles
import '@/styles/main.scss'

// Vuetify
import { createVuetify, type ThemeDefinition } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import {
  mdiCalendarCheck,
  mdiCalendarPlus,
  mdiChevronDown,
  mdiDirections,
  mdiFacebook,
  mdiHandFrontRight,
  mdiHandHeartOutline,
  mdiHome,
  mdiInstagram,
  mdiMapMarker,
  mdiMapOutline,
  mdiPhone,
  mdiSpa,
  mdiWaterOutline,
  mdiWhatsapp,
} from '@mdi/js'

const iconAliases = {
  ...aliases,
  'mdi-calendar-check': mdiCalendarCheck,
  'mdi-calendar-plus': mdiCalendarPlus,
  'mdi-chevron-down': mdiChevronDown,
  'mdi-directions': mdiDirections,
  'mdi-facebook': mdiFacebook,
  'mdi-hand': mdiHandFrontRight,
  'mdi-hand-heart-outline': mdiHandHeartOutline,
  'mdi-home': mdiHome,
  'mdi-instagram': mdiInstagram,
  'mdi-map-marker': mdiMapMarker,
  'mdi-map-outline': mdiMapOutline,
  'mdi-phone': mdiPhone,
  'mdi-spa': mdiSpa,
  'mdi-water-outline': mdiWaterOutline,
  'mdi-whatsapp': mdiWhatsapp,
}

type ThemeSeed = {
  background: string
  primary: string
  secondary: string
  text: string
  headerBg: string
  headerText: string
}

const makeTheme = (seed: ThemeSeed): ThemeDefinition => ({
  dark: false,
  colors: {
    background: seed.background,
    surface: seed.background,
    primary: seed.primary,
    'primary-darken-1': seed.primary,
    secondary: seed.secondary,
    'secondary-darken-1': seed.secondary,
    error: '#c62828',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
    'on-background': seed.text,
    'on-surface': seed.text,
    'header-bg': seed.headerBg,
    'header-text': seed.headerText,
  },
  variables: {}
})

const jasmineHoneyTeakBalanceTheme = makeTheme({
  background: '#f6f0e0',
  primary: '#5a6b42',
  secondary: '#4e5e38',
  text: '#3f402e',
  headerBg: '#ebe1c8',
  headerText: '#4d5b39',
})

const jasmineHoneyTeakSoftTheme = makeTheme({
  background: '#f7f2e4',
  primary: '#60724a',
  secondary: '#536441',
  text: '#434231',
  headerBg: '#ece4ce',
  headerText: '#51603c',
})

const jasmineHoneyTeakDeepTheme = makeTheme({
  background: '#f4eddb',
  primary: '#4e603b',
  secondary: '#445432',
  text: '#3a3d2b',
  headerBg: '#e7ddc1',
  headerText: '#465334',
})

export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases: iconAliases,
    sets: {
      mdi,
    },
  },
  theme: {
    // defaultTheme: 'jasmineHoneyTeakBalanceTheme',
    defaultTheme: 'jasmineHoneyTeakSoftTheme',
    // defaultTheme: 'jasmineHoneyTeakDeepTheme',
    themes: {
      jasmineHoneyTeakBalanceTheme,
      jasmineHoneyTeakSoftTheme,
      jasmineHoneyTeakDeepTheme,
    },
  },
})
